import { useState } from "react";
import { toast } from "sonner";
import { PageHead } from "../components/PageHead";
import { api, errMsg, useApi } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function Users() {
  const { user } = useAuth();
  const { data, reload } = useApi("/users");
  const { data: staff } = useApi("/staff");
  const blank = { email: "", name: "", role: "staff", password: "", staff_id: "" };
  const [f, setF] = useState(blank);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const roles = ["staff", "manager", "hr", "gm", "executive"].concat(user?.role === "admin" ? ["admin"] : []);
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/users", { ...f, staff_id: f.staff_id || null });
      toast.success("Account created");
      setF(blank);
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const toggle = async (u) => {
    try {
      await api.patch(`/users/${u.id}`, { active: !u.active });
      reload();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <div data-testid="users-page">
      <PageHead eyebrow="Administration" title="Accounts & roles">No public sign-up. Only administrators and the GM can create accounts.</PageHead>
      <div className="p-5 md:p-10 grid lg:grid-cols-3 gap-6">
        <form onSubmit={submit} className="panel p-5 grid gap-3 h-fit" data-testid="user-create-form">
          <div className="eyebrow">New account</div>
          <input required className="field" placeholder="Full name" value={f.name} onChange={set("name")} data-testid="user-name-input" />
          <input required type="email" className="field" placeholder="Email" value={f.email} onChange={set("email")} data-testid="user-email-input" />
          <input required minLength={8} type="password" className="field" placeholder="Temporary password (8+ chars)" value={f.password} onChange={set("password")} data-testid="user-password-input" />
          <select className="field" value={f.role} onChange={set("role")} data-testid="user-role-select">{roles.map((r) => <option key={r}>{r}</option>)}</select>
          <select className="field" value={f.staff_id} onChange={set("staff_id")} data-testid="user-staff-select">
            <option value="">Link to staff record (optional)</option>
            {(staff || []).map((s) => <option key={s.id} value={s.id}>{s.name} — {s.role}</option>)}
          </select>
          <button className="btn-gold" data-testid="user-create-btn">Create account</button>
        </form>
        <div className="lg:col-span-2 panel divide-y divide-[color:var(--line)]">
          {(data || []).map((u) => (
            <div key={u.id} className="p-4 flex items-center justify-between gap-3" data-testid={`user-row-${u.email}`}>
              <div><div className="text-ink text-sm">{u.name}</div><div className="text-[11px] text-slate-500">{u.email}</div></div>
              <div className="flex items-center gap-3">
                <span className="pill pill-gold">{u.role}</span>
                {u.id !== user.id && <button onClick={() => toggle(u)} className={`text-xs ${u.active ? "text-red-400" : "text-green-400"} hover:underline`} data-testid={`user-toggle-${u.email}`}>{u.active ? "Disable" : "Enable"}</button>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
